const icon = require('vue-svgicon');
icon.register({
    'minus-round': {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        data: `<rect pid="0" y="1" width="23" height="23" rx="11.5" _fill="#DFDFDF"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M12 12H6v1h11v-1h-5V7z" _fill="#000"/>`,
    },
});
